/**
 * Javascript for product pages
 */
(function (window, document, $, undefined) {
    'use strict';

    var checkboxes = $('input[type=checkbox]');

    checkboxes.each(function(){

        var $this = $(this);
        var $jhCheckbox = $('<div class="jh-checkbox"></div>');

        // need to include the jh-checkbox--checked class if the checkbox input is checked
        if( $this.is(':checked')){
            var $jhCheckbox = $('<div class="jh-checkbox jh-checkbox--checked"></div>');
        }
        

        if( $this.attr('data-required') ) {
            $jhCheckbox.attr('data-required', $this.attr('data-required') );
            $this.removeAttr('data-required');
        }

        $this.wrap( $jhCheckbox );
        $this.before('<span>&#xf00c;</span>');
    });

    checkboxes.change(function(){
        if($(this).is(':checked')){
            $(this).parent().addClass('jh-checkbox--checked');
        } else {
            $(this).parent().removeClass('jh-checkbox--checked');
        }
    });

})( window, document, jQuery );
